import { render, staticRenderFns } from "./ThresholdAlarmSetting.vue?vue&type=template&id=3201c182&scoped=true"
import script from "./ThresholdAlarmSetting.vue?vue&type=script&lang=js"
export * from "./ThresholdAlarmSetting.vue?vue&type=script&lang=js"
import style0 from "./ThresholdAlarmSetting.vue?vue&type=style&index=0&id=3201c182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3201c182",
  null
  
)

export default component.exports